import { measureUnit } from '../unit/measure'
import { i18n } from '@b2ag/locale'

const NUMBER_SETTINGS = { maximumFractionDigits: 2 } as const
const ROUND_NUMBER_SETTINGS = { maximumFractionDigits: 0 } as const
const PRECISE_NUMBER_SETTINGS = { maximumFractionDigits: 5 } as const

const PRICE_NUMBER_SETTINGS = { ...NUMBER_SETTINGS, minimumFractionDigits: 2 } as const
const ROUND_PRICE_NUMBER_SETTINGS = ROUND_NUMBER_SETTINGS

const DISCOUNT_PRICE_NUMBER_SETTINGS = NUMBER_SETTINGS

const PRECISE_PRICE_NUMBER_SETTINGS = {
  ...PRECISE_NUMBER_SETTINGS,
  minimumFractionDigits: 2,
  currencyDisplay: 'narrowSymbol',
} as const

const PRICE_SETTINGS = {
  ...PRICE_NUMBER_SETTINGS,
  style: 'currency',
  currencyDisplay: 'narrowSymbol',
} as const

const ROUND_PRICE_SETTINGS = {
  ...ROUND_PRICE_NUMBER_SETTINGS,
  style: 'currency',
  currencyDisplay: 'narrowSymbol',
} as const

const PRECISE_PRICE_SETTINGS = {
  ...PRECISE_PRICE_NUMBER_SETTINGS,
  style: 'currency',
  currencyDisplay: 'narrowSymbol',
} as const

const DISCOUNT_PRICE_SETTINGS = {
  ...DISCOUNT_PRICE_NUMBER_SETTINGS,
  style: 'currency',
  currencyDisplay: 'narrowSymbol',
} as const

export const { format: formatNumber } = new Intl.NumberFormat('fr-FR', NUMBER_SETTINGS)

export const { format: formatPreciseNumber } = new Intl.NumberFormat('fr-FR', PRECISE_NUMBER_SETTINGS)

export const { format: formatNumber3Digits } = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 3 })

export const { format: formatPriceNumber } = new Intl.NumberFormat('fr-FR', PRICE_NUMBER_SETTINGS)

export const formatPrecisePriceNumber = (n: number) => {
  const { format } = new Intl.NumberFormat(i18n.locale, { ...PRECISE_PRICE_NUMBER_SETTINGS, currency: i18n.currency })
  return format(n)
}

export const formatPrice = (n: number) => {
  const { format } = new Intl.NumberFormat(i18n.locale, { ...PRICE_SETTINGS, currency: i18n.currency })
  return format(n)
}

/**
 * @deprecated
 * @see {@link formatPrice}
 */
export const formatEuros = formatPrice

export const formatRoundPrice = (n: number) => {
  const { format } = new Intl.NumberFormat(i18n.locale, { ...ROUND_PRICE_SETTINGS, currency: i18n.currency })
  return format(n)
}

export const formatDiscountPrice = (n: number) => {
  if (Number.isInteger(n)) return formatRoundPrice(n)
  const { format } = new Intl.NumberFormat(i18n.locale, { ...DISCOUNT_PRICE_SETTINGS, currency: i18n.currency })
  return format(n)
}

/**
 * @deprecated
 * @see {@link formatRoundPrice}
 */
export const formatRoundEuros = formatRoundPrice

export const formatPrecisePrice = (n: number) => {
  const { format } = new Intl.NumberFormat(i18n.locale, { ...PRECISE_PRICE_SETTINGS, currency: i18n.currency })
  return format(n)
}

export const formatQuantity = (n: number, unit?: string) =>
  unit ? `${formatNumber3Digits(n)}\xa0${measureUnit(unit, n)}` : formatNumber3Digits(n)

export const formatMeasureUnit = (n: number, unit?: string) =>
  unit ? `${formatNumber(n)}\xa0${measureUnit(unit, n)}` : formatNumber(n)
